<template>
  <div class="centerx popup">
    <!-- <vs-button @click="active=true" color="primary" type="border">Open Default popup</vs-button> -->
    <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
      <div class="content">
        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
          <input type="hidden" name="_token" :value="csrf">
          <input v-if="this.editing" type="hidden" name="_method" value="PUT">
          <input name="peopleAbsence[person_id]" type="hidden" v-model="this.parameters.person_id">
          <div class="form-group row">
              <label for="cause_id" class="col-2 col-form-label">{{__('views.AbsenceCause.cause')}}</label>
              <div class="col-10">
                <!-- v-model="this.parameters.cause_id" -->
                  <select name="peopleAbsence[cause_id]" v-model="parameters.cause_id" class="form-control" style="width: 100%;">
                      <option disabled value="">{{ __('misc.select') }}</option>
                      <option v-for="absence_cause in this.absence_causes" :value="absence_cause.id"> {{absence_cause.cause}}</option>
                  </select>
              </div>
          </div>
          <div class="form-group row">
              <label for="name" class="col-2 col-form-label">{{__('views.AbsenceCause.startAbsence')}}</label>
              <div class="col-10">
                  <vue-datepicker
                      input_class="form-control"
                      input_name="peopleAbsence[start_date]"
                      :input_value="this.parameters.start_date"
                  ></vue-datepicker>
              </div>
          </div>
          <div class="form-group row">
              <label for="name" class="col-2 col-form-label">{{__('views.AbsenceCause.endAbsence')}}</label>
              <div class="col-10">
                    <vue-datepicker
                        input_class="form-control"
                        input_name="peopleAbsence[end_date]"
                        :input_value="this.parameters.end_date"
                    ></vue-datepicker>
              </div>
          </div>
          <div class="col-lg-3 float-right">
              <button type="submit" class="btn btn-rounded btn-block btn-success">{{ __('misc.update') }} </button>
          </div>
        </form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  export default {
    mounted() {
      axios.get("/api/absence-causes")
        .then((response) => {
          this.absence_causes = response.data.data;
        });
    },
    data()  {
      return {
        absence_causes: [],
        action: "",
        editing: false,
        active: false,
        title: "",
        parameters: {},
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    },

    methods: {
      toggle(action, item_id, editing, attributes) {
        this.active = true;
        this.action = action;
        this.editing = editing;
        let url = attributes.url;
        if (url!==undefined) {
          if (url.indexOf("[id]")>0) {
            url = url.replace("[id]", item_id);
          }
          axios.get(url)
              .then((response) => {
                this.parameters = response.data;
              });
        }
      }
    },

  }
</script>

